import React from "react";

import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { LanguageListItem } from "@components/General/LanguageSelector/layouts/list/listItem.component";

import "./list.scss";

type Props = {
    variant?: string;
    languages: Language[];
    current: string;
};

const LanguageListSelector = ({ current, languages, variant }: Props) => {
    return (
        <div className="my-1">
            <ul className="language-selector__list">
                {languages.map(language => (
                    <li
                        className="language-selector__list-item"
                        key={language.languageCode}
                    >
                        <LanguageListItem
                            language={language}
                            isCurrent={language.languageCode === current}
                            variant={variant}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LanguageListSelector;
